import { about } from './about.js';
import { dissertation } from './dissertation.js';
import { childhood } from './childhood.js';
import { extracurricular } from './extracurricular.js';
import { robotics } from './robotics.js';
import { skills } from './skills.js';
import { experience } from './experience.js';
import { contact } from './contact.js';

// Display order is explicit. Keep each section's id stable so shared links work.
export const sections = [about, dissertation, childhood, extracurricular, robotics, skills, experience, contact];
